import { ADMIN_PROSPECT_RESPONSE_INTENTS } from './adminProspectDisplay.js';

/**
 * Validate focus identity from HashRouter location state. Never invent missing pieces.
 * @returns {{ campaignId: string, mailingId: string, intent: string } | null}
 */
export function parseFocusedPublicResponseIdentity({
  campaignId,
  mailingId,
  intent,
} = {}) {
  const c = typeof campaignId === 'string' ? campaignId.trim() : '';
  const m = typeof mailingId === 'string' ? mailingId.trim() : '';
  const i = typeof intent === 'string' ? intent.trim() : '';
  if (!c || !m || !i) return null;
  if (!ADMIN_PROSPECT_RESPONSE_INTENTS.includes(i)) return null;
  return { campaignId: c, mailingId: m, intent: i };
}

/**
 * Select the exact intent from a mailing public-response DTO. Never substitutes another intent.
 * @returns {{ status: 'ready', item: object } | { status: 'unavailable' }}
 */
export function selectFocusedPublicResponseIntent(responses, intent) {
  const wanted = typeof intent === 'string' ? intent.trim() : '';
  if (!wanted) return { status: 'unavailable' };
  const list = Array.isArray(responses) ? responses : [];
  const match = list.find((row) => row?.intent === wanted);
  if (!match) return { status: 'unavailable' };
  return { status: 'ready', item: match };
}

/**
 * Stale-completion protection for focused public-response loads (visitId + authUid).
 */
export function shouldApplyFocusedPublicResponseResult({
  mounted,
  requestId,
  activeRequestId,
  requestVisitId,
  activeVisitId,
  requestAuthUid,
  activeAuthUid,
}) {
  if (!mounted) return false;
  if (!requestId || requestId !== activeRequestId) return false;
  if (requestVisitId !== activeVisitId) return false;
  if (String(requestAuthUid || '') !== String(activeAuthUid || '')) return false;
  return true;
}
